import { isIE, browserVersion, isMobile, isTablet } from 'react-device-detect';

export const isIE11 = () => isIE && browserVersion === '11.0';
const isSmallMobileDevice = isMobile && !isTablet;

export { isMobile, isTablet, isSmallMobileDevice };
